import styled, { css } from 'styled-components';

import { Table } from '..';

import { StyledTableProps } from './types';

const colorStyle = css<StyledTableProps>`
  color: ${props =>
    props.isClosedInvoice
      ? props.theme.yoga.colors.deep
      : props.theme.yoga.colors.text.primary};
`;

export const StyledTable = styled(props => (
  <Table {...props} />
))<StyledTableProps>`
  table-layout: fixed;

  thead tr {
    text-indent: ${({ theme }) => theme.yoga.spacing.zero};
    border-bottom: ${({ theme }) =>
        `${theme.yoga.colors.tableBorder} ${theme.yoga.borders.small}px`}
      solid;

    th {
      text-transform: uppercase;
      padding: ${({ theme }) => theme.yoga.spacing.medium}px;

      > div {
        ${colorStyle};
        font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
        font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
        line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
      }
    }

    &::after {
      display: none;
    }
  }

  tbody tr {
    text-indent: ${({ theme }) => theme.yoga.spacing.zero};

    td {
      ${colorStyle};

      font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
      font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
      line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      padding: ${props =>
        props.loading
          ? props.theme.yoga.spacing.zero
          : `${props.theme.yoga.spacing.medium}px`};
    }

    &:last-child {
      background: ${props =>
        props.loading
          ? 'none'
          : props.theme.yoga.colors.backgroundLight} !important;

      > td {
        font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
      }
    }

    &:nth-child(even) {
      background-color: ${({ theme }) => theme.yoga.colors.elements.disabled};
    }

    &:nth-child(odd) {
      background-color: ${({ theme }) => theme.yoga.colors.white};
    }
  }
`;

export const Container = styled.div``;
